/** User-facing copy when IndexedDB SQLite persist fails (quota, IDB dead, etc.). */
export const LOCAL_SQLITE_PERSIST_ERROR_TOAST =
  'No se pudo guardar en el dispositivo. Revise Observabilidad o libere espacio.';

type PersistErrorHandler = (error: unknown) => void;

let handler: PersistErrorHandler | undefined;
let lastPersistError: string | undefined;

export function bindLocalSqlitePersistErrorHandler(next: PersistErrorHandler | undefined): void {
  handler = next;
}

export function getLastLocalSqlitePersistError(): string | undefined {
  return lastPersistError;
}

export function clearLastLocalSqlitePersistError(): void {
  lastPersistError = undefined;
}

/** Log + optional UI sink. Never throws. */
export function notifyLocalSqlitePersistError(error: unknown): void {
  const message = error instanceof Error ? error.message : String(error);
  lastPersistError = message;
  // oxlint-disable-next-line no-console -- persist path has no TelemetryPort
  console.warn('[local-sqlite] persist failed', error);
  try {
    handler?.(error);
  } catch (handlerErr) {
    // oxlint-disable-next-line no-console -- handler must not break unload flush
    console.warn('[local-sqlite] persist error handler failed', handlerErr);
  }
}

export function resetLocalSqlitePersistErrorForTests(): void {
  handler = undefined;
  lastPersistError = undefined;
}
